import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";

import { useCallback, useEffect, useRef, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";

import { green, grey } from "@mui/material/colors";
import { GlobalState } from "context/GlobalContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CircularProgress, Divider, Switch } from "@mui/material";
import PublishModal from "./PublishModal/PublishModal";
import { PimDashboardState } from "context/PimDashboardContext";
import {
	attrGroupLinkedTables,
	productionStageOptions,
	productPagePath,
	publishTableColumn,
	styleImagesAssocObj,
} from "components/PimDashboard/data";
import { styleUrlKey } from "../CreateStyle/data";
import {
	converAttrToDatagridCol,
	createdByColumns,
	imageTableColumn,
	publishColumns,
	stageTableColumn,
	statusOptions,
	styleImageColumn,
} from "data/globalData";
import { FileDownloadRounded, FilterAltRounded, PlaylistAddRounded, SwapVertRounded } from "@mui/icons-material";
import FileSaver from "file-saver";
import FilterModal from "./FilterModal/FilterModal";
import AddColumnModal from "./AddColumnModal/AddColumnModal";
import { allowAccess } from "utils/userAccessFun";
import { custom, departments } from "data/authData";
import { AuthState } from "context/AuthContext";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import RenderStyleCountBarGraph from "./RenderStyleCountBarGraph/RenderStylerCountGraph";
import { lsStylesFilterValStr } from "./data";
import _ from "lodash";

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const graphList = [
	{
		name: "SHIRT",
		key: "SHIRT",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
	{
		name: "T-SHIRT",
		key: "T-SHIRT",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
	{
		name: "POLO",
		key: "POLO",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
	{
		name: "JACKET",
		key: "JACKET",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
	{
		name: "DENIM PANT",
		key: "DENIM PANT",
		graphSeries: [
			{ data: [20, 24], label: "Style Count" },
			{ data: [80, 100], label: "Color Count" },
		],
	},
];

const RenderCategoryLevelGraphs = ({ list, sx = {}, ...rest }) => {
	return (
		<Box display="flex" {...rest} sx={{ overflowX: "scroll", ...sx }} columnGap={2}>
			{list?.map((row) => {
				return (
					<Stack>
						<RenderStyleCountBarGraph
							width={140}
							height={120}
							xAxis={[{ data: ["SS-25", "SS-24"], scaleType: "band", categoryGapRatio: 0.4, barGapRatio: 0.2 }]}
							dataArr={row?.graphSeries}
						/>
						<Typography variant="subtitle1" fontSize={14} fontWeight={600} textAlign="center">
							{row?.name}
						</Typography>
					</Stack>
				);
			})}
		</Box>
	);
};

export function setStylesCustomFun(prev, newRows) {
	const map = {};

	const result = [...prev, ...newRows]?.reduce((acc, row) => {
		if (map[row.style_id]) return acc;
		else {
			acc.push(row);
			map[row.style_id] = true;
		}
		return acc;
	}, []);
	return result;
}

const StylesDashboard = () => {
	const gridRef = useRef();
	const { allAttributes, allAttributesObj } = PimDashboardState();
	const { user } = AuthState();
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [styles, setStyles] = useState([]);
	const [displayImg, setDisplayImg] = useState(true);
	const [selectedStyleToPublish, setSelectedStyleToPublish] = useState();
	const [tableStatusCount, setTableStatusCount] = useState({
		total: 0,
		pending: 0,
		published: 0,
	});
	const [publishModal, setPublishModal] = useState(false);
	const [filterModal, setFilterModal] = useState(false);
	const [addColumnModal, setAddColumnModal] = useState(false);

	const defColumns = [
		{
			field: "color_count",
			headerName: "Colors",
			width: 80,
			...colStyle,
		},
		...createdByColumns.map((row) => converAttrToDatagridCol(row)),
	];

	const [styleTablColumns, setStyleTableColumns] = useState(defColumns);

	const [attrColumns, setAttrColumns] = useState(() => {
		if (localStorage.getItem("styles_table_attr")) {
			return JSON.parse(localStorage.getItem("styles_table_attr"))
				?.map((row) => {
					return { ...allAttributesObj?.[row] };
				})
				.map((row) => converAttrToDatagridCol(row));
		} else
			return allAttributes
				?.filter((row) => row?.linked_table === attrGroupLinkedTables.style.key)
				?.map((row) => converAttrToDatagridCol(row));
	});

	const [filterColumns, setFilterColumns] = useState(
		// appling filter fron local storage data
		() => {
			let final = [];
			if (localStorage.getItem(lsStylesFilterValStr)) {
				const localStorageObj =
					typeof JSON.parse(localStorage.getItem(lsStylesFilterValStr)) === "object"
						? JSON.parse(localStorage.getItem(lsStylesFilterValStr))
						: {};
				[...defColumns, ...allAttributes, ...Object.keys(publishColumns).map((row) => publishColumns[row])]?.forEach((row) => {
					if (localStorageObj?.[row?.key]) final.push(row);
				});
				return final;
			}
		}
	);
	const [filterColumnVal, setFilterColumnVal] = useState(() => {
		if (localStorage.getItem(lsStylesFilterValStr)) {
			return JSON.parse(localStorage.getItem(lsStylesFilterValStr));
		} else {
			return {};
		}
	});
	const [offset, setOffset] = useState(0);
	const [recordsLimit] = useState(20);
	const [hasMore, setHasMore] = useState(true);
	const [loading, setLoading] = useState(false);

	const handleCloseFilterModal = () => {
		setFilterModal(false);
	};

	const handleCloseAddColumnModal = () => {
		setAddColumnModal(false);
	};

	const handleFilterClick = () => {
		setFilterModal(true);
	};

	const handleAddColumnClick = () => {
		setAddColumnModal(true);
	};

	const fetchStyles = async (offset, limit) => {
		try {
			const extraColumns = attrColumns?.reduce((acc, row) => {
				acc[row.field] = true;
				return acc;
			}, {});

			const { data } = await axios.post(`/api/designer/styles/${offset}`, {
				filter: filterColumnVal,
				extraColumns,
				limit,
			});
			setStyles((prev) => setStylesCustomFun(prev, data.result.styles));
			setTableStatusCount(data.result.count[0]);
			setOffset((prev) => prev + recordsLimit);
			return data.result || [];
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			return [];
		}
	};

	const loadMoreData = useCallback(
		_.throttle(async () => {
			if (loading || !hasMore) return;
			if (styles?.length > 100) return;
			setLoading(true);

			const newRows = await fetchStyles(offset, recordsLimit);

			if (newRows.length < recordsLimit) setHasMore(false);
			setLoading(false);
		}, 2000),
		[loading, hasMore, offset]
	);

	useEffect(() => {
		const gridElement = gridRef.current;
		if (!gridElement) return;

		const scrollContainer = gridElement.querySelector(".MuiDataGrid-virtualScroller");

		if (!scrollContainer) return;

		const handleScroll = () => {
			const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
			if (scrollHeight - scrollTop <= clientHeight + 100) {
				loadMoreData();
			}
		};

		scrollContainer.addEventListener("scroll", handleScroll);

		return () => {
			scrollContainer.removeEventListener("scroll", handleScroll);
		};
	}, [loadMoreData]);
	useEffect(() => {
		const fetchInitialStyles = async () => {
			setLoadingOpen(true);
			setStyleTableColumns([
				publishTableColumn(handlePublishClick, !allowAccess(custom.STYLE_PUBLISHER.key, user, departments.DESIGNER.key)),
				imageTableColumn(styleImageColumn),
				...attrColumns,
				...defColumns,
				stageTableColumn(productionStageOptions),
			]);
			const result = await fetchStyles(0, recordsLimit);
			setStyles(result.styles);
			setTableStatusCount(result.count[0]);
			setOffset((prev) => prev + recordsLimit);
			setHasMore(result.styles.length === recordsLimit);
			setLoadingOpen(false);
		};

		fetchInitialStyles();
	}, [filterColumns, attrColumns]);

	const navigate = useNavigate();

	const handleImageSwitchChange = (checked) => {
		setDisplayImg(checked);
	};

	const handleStyleSelect = async (data) => {
		navigate(`/${productPagePath}?${styleUrlKey}=${data.style_id}`);
	};
	const handleDownloadClick = async () => {
		setLoadingOpen(true);
		try {
			await axios({
				url: `/api/designer/download_styles`,
				method: "POST",
				responseType: "blob",
				data: { filter: filterColumnVal },
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `allStyles.xlsx`);
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};
	const handlePublishClick = (e, styleData) => {
		e.stopPropagation();
		setPublishModal(true);
		setSelectedStyleToPublish(styleData);
	};
	const onPublishFinalSubmit = (styleData) => {
		setStyles(
			styles.map((style) => {
				if (style.style_id === styleData.style_id) {
					return { ...styleData };
				} else return style;
			})
		);
		// setTableStatusCount(tableStatusCount - 1);
		setPublishModal(false);
		setSelectedStyleToPublish();
	};

	return (
		<Stack width="100%" pt={1}>
			<Box display="flex" justifyContent="space-around">
				{/* left section */}
				<Stack spacing={1} width="28%">
					<Box display="flex" columnGap={1} pt={1} flexWrap="wrap" alignItems="center" rowGap={"5px"}>
						<Button
							variant="contained"
							size="small"
							startIcon={<FilterAltRounded />}
							onClick={handleFilterClick}
							sx={{ textTransform: "capitalize" }}>
							Filter
						</Button>
						:
						{!filterColumns?.length && (
							<Typography variant="body1" fontSize={16} color={grey[700]}>
								None
							</Typography>
						)}
						{filterColumns?.map((row) => {
							return (
								<Chip
									label={`${row.name} : ${
										Array.isArray(filterColumnVal[row?.key])
											? filterColumnVal[row?.key]?.join(", ")
											: filterColumnVal?.[row?.key]
									}`}
									size="small"
								/>
							);
						})}
					</Box>
					<Box>
						<Button
							variant="contained"
							sx={{ textTransform: "capitalize", mr: 1 }}
							size="small"
							onClick={handleAddColumnClick}
							startIcon={<PlaylistAddRounded />}>
							Manage Columns
						</Button>
						<Button
							variant="contained"
							size="small"
							sx={{ textTransform: "capitalize" }}
							onClick={handleDownloadClick}
							startIcon={<FileDownloadRounded />}>
							Download
						</Button>
					</Box>
				</Stack>
				{/* right section */}
				<Box width="68%">
					<RenderCategoryLevelGraphs
						border={`1px solid ${grey[300]}`}
						borderRadius={1}
						width="100%"
						list={graphList}
						p={1}
						sx={{ display: "none" }}
					/>
				</Box>
			</Box>
			<Box display="flex" justifyContent="space-between" alignItems="center" pt={1}>
				<Box display="flex" alignItems="center">
					<Typography variant="h6">Images</Typography>
					<Switch checked={displayImg} onChange={(e) => handleImageSwitchChange(e.target.checked)} sx={{ mt: 1 }} />
				</Box>
				<Box display="flex" alignItems="center" columnGap={1}>
					<Typography variant="body1">
						Total: <span style={{ color: grey[700] }}>{tableStatusCount.total}</span>
					</Typography>
					<Divider orientation="vertical" flexItem />
					<Typography variant="body1">
						Published: <span style={{ color: green[600] }}>{tableStatusCount.published}</span>
					</Typography>
					<Divider orientation="vertical" flexItem />
					<Typography variant="body1" fontWeight={600}>
						Pending: <span style={{ color: "red" }}>{tableStatusCount.pending}</span>
					</Typography>
				</Box>
			</Box>

			<Box height="60vh" ref={gridRef}>
				<DataGrid
					rows={styles ? styles : []}
					key={displayImg}
					columns={styleTablColumns ?? []}
					sx={{
						// minWidth: "100%"
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
						"& .MuiDataGrid-footer": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
					}}
					columnHeaderHeight={35}
					rowHeight={displayImg ? 70 : 40}
					getRowId={(row) => row?.style_id}
					onRowClick={(params, e) => handleStyleSelect(params.row)}
					initialState={{
						columns: {
							columnVisibilityModel: {
								[styleImageColumn.key]: displayImg,
							},
						},
					}}
					disableRowSelectionOnClick
					hideFooter={true}
					pagination={false}
					// disableColumnFilter
					disableColumnSelector
					disableAutosize
				/>
				{/* <Box sx={{ minHeight: "20px" }}> */}
				{loading && (
					<Box display="flex" sx={{ background: grey[400], borderRadius: 2, p: 1 }} alignItems="center">
						<Typography variant="body2" color={grey[900]}>
							Loading...
						</Typography>
						<CircularProgress size="18px" sx={{ transform: "scale(0.4)" }} />
					</Box>
				)}
			</Box>

			<PublishModal
				modal={publishModal}
				setModal={setPublishModal}
				styleData={selectedStyleToPublish}
				setStyleData={setSelectedStyleToPublish}
				submitFunction={onPublishFinalSubmit}
			/>
			<FilterModal
				modal={filterModal}
				handleCloseModal={handleCloseFilterModal}
				filterColumns={filterColumns}
				setFilterColumns={setFilterColumns}
				filterColumnVal={filterColumnVal}
				setFilterColumnVal={setFilterColumnVal}
				localStorageStr={lsStylesFilterValStr}
			/>
			<AddColumnModal
				modal={addColumnModal}
				handleCloseModal={handleCloseAddColumnModal}
				attrColumns={attrColumns}
				setAttrColumns={setAttrColumns}
				localStorageStr={"styles_table_attr"}
			/>
		</Stack>
	);
};

export default StylesDashboard;
